import React, { useState } from 'react';
import { faqData, getAllFAQCategories } from '../../data/faqData';
import Accordion from '../../components/common/Accordion';

const FAQ = () => {
  const [selectedCategory, setSelectedCategory] = useState('Tümü');
  const categories = ['Tümü', ...getAllFAQCategories()];

  // Filter FAQs by category
  const filteredFAQs =
    selectedCategory === 'Tümü'
      ? faqData
      : faqData.filter((faq) => faq.category === selectedCategory);

  // Transform faqData for Accordion component
  const accordionItems = filteredFAQs.map((faq) => ({
    id: faq.id,
    question: faq.question,
    answer: faq.answer,
  }));

  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gray-50 py-16 md:py-24">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Sıkça Sorulan Sorular
          </h1>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            Merak ettiğiniz her şeyi burada bulabilirsiniz. Daha fazla bilgi için
            bizimle iletişime geçebilirsiniz.
          </p>
        </div>
      </section>

      {/* Category Filters */}
      <section className="py-8 bg-white border-b border-gray-200">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="flex flex-wrap justify-center gap-3">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-5 py-2 rounded-full text-sm font-semibold transition-colors
                    ${
                      selectedCategory === category
                        ? 'bg-primary-500 text-white'
                        : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                    }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            {/* Results Count */}
            <div className="mb-8 text-center">
              <p className="text-gray-600 text-base">
                {filteredFAQs.length} soru gösteriliyor
                {selectedCategory !== 'Tümü' && (
                  <span className="font-semibold text-gray-900">
                    {' '}
                    - {selectedCategory} kategorisi
                  </span>
                )}
              </p>
            </div>

            {/* Accordion */}
            {accordionItems.length > 0 ? (
              <Accordion items={accordionItems} />
            ) : (
              <div className="text-center py-20">
                <p className="text-gray-500 text-xl mb-4">
                  <span userType="img" aria-label="search">
                    🔍
                  </span>{' '}
                  Bu kategoride soru bulunamadı.
                </p>
                <p className="text-gray-500 text-base">
                  Lütfen başka bir kategori seçin veya tüm soruları görüntüleyin.
                </p>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 text-center">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Cevap Bulamadınız mı?
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              Sorularınız için destek ekibimizle iletişime geçebilirsiniz. Size
              yardımcı olmaktan mutluluk duyarız.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/contact"
                className="inline-block px-8 py-4 bg-primary-500 text-white font-semibold rounded-lg hover:bg-primary-600 transition-colors text-lg"
              >
                Bize Ulaşın
              </a>
              <a
                href="mailto:destek@contractcode.com.tr"
                className="inline-block px-8 py-4 bg-white border-2 border-gray-300 text-gray-900 font-semibold rounded-lg hover:bg-gray-50 transition-colors text-lg"
              >
                E-posta Gönderin
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

FAQ.propTypes = {};

export default FAQ;

